import { StyleSheet, TextInput, Platform } from "react-native";
import { appColors } from "../constants/colors";

export default function Input({ value, onChangeText, onFocus, onBlur, error, isError }) {
  return (
    <TextInput
      onBlur={onBlur}
      onFocus={onFocus}
      onChangeText={onChangeText}
      value={`${value}`}
      inputMode="numeric"
      keyboardType={Platform.OS === "ios" ? "decimal-pad" : "numeric"}
      style={[styles.input, isError && error]}
    />
  );
}

const styles = StyleSheet.create({
  input: {
    backgroundColor: appColors.inputBg,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "transparent",
    paddingVertical: 5,
    paddingHorizontal: 10,
    fontSize: 12,
    fontWeight: "500",
    color: appColors.primary,
    textAlign: "right",
    minWidth: 90,
  },
});
